<template>
  <div class="map">
    <map-panel />
  </div>
</template>

<script>
import MapPanel from '../components/organisms/Map/MapPanel'
import Constants from "@/constants";
//import middle from "@/api/middle_layer";

export default {
  created () {
    const serviceAreaId = this.$route.query.serviceAreaId
    const token = this.$route.query.token
    const s = Constants.DOCOMO_SERVICE_AREAS.find((s) => s.id == serviceAreaId)
    const center = {
      lat: parseFloat(s.location.lat), // parseFloat(this.$route.query.lat),
      lng: parseFloat(s.location.lng), //parseFloat(this.$route.query.lng)
    }
    this.$store.dispatch('loading/beginLoading')
    this.$store.dispatch('reservation/activateMode', parseInt(serviceAreaId))
    if (center.lat && center.lng) {
      this.$store.dispatch('map/updateCenter', center)
    }
    if (token) {
      this.$store.dispatch('user/create', { serviceAreaId, token })
        .then(() => {
          this.$store.dispatch('serviceAreas/fetch', serviceAreaId)
          this.$store.dispatch('busstops/fetchAll')
            .then(() => {
              this.$store.dispatch('reservation/updateStatusTentative')
              this.$store.dispatch('drawer/forceOpen')
            })  
            .finally(() => {
              this.$store.dispatch('loading/endLoading')
            })
        })
    }
  },
  components: {
    MapPanel
  }
}
</script>
